const commentItems = [
  {
    name: '吃瓜第一线',
    avatar: 'R',
    time: '2小时前',
    content: '自从用了51吃瓜app，再也不怕错过任何热点了！每天早上打开刷一刷，比刷微博还过瘾。轻量版对老手机也很友好，已经安利给身边所有朋友了。',
    likes: '328',
  },
  {
    name: '娱乐圈观察员',
    avatar: 'Y',
    time: '5小时前',
    content: '内容更新是真的快，有时候热搜还没上呢这边就已经有详细梳理了。苹果版的体验特别流畅，界面也很清爽，没有乱七八糟的广告。推荐下载51吃瓜网app，绝对值。',
    likes: '256',
  },
  {
    name: '追剧小达人',
    avatar: 'Z',
    time: '1天前',
    content: '最爱的功能就是话题追踪，把喜欢的明星设置关注后，有相关动态会第一时间推送。安卓下载也很方便，安装包不大，功能却很齐全。51吃瓜轻量版适合备用机，强烈推荐！',
    likes: '189',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            用户心声
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[500px] mx-auto">
            来看看吃瓜群众们怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 max-w-[1100px] mx-auto">
          {commentItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-lg p-5 md:p-6 border border-background-200/60"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-primary-600 font-bold text-sm">
                    {item.avatar}
                  </span>
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-bold text-foreground-900 whitespace-nowrap">
                    {item.name}
                  </p>
                  <p className="text-xs text-foreground-400">{item.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                "{item.content}"
              </p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-thumb-up-line"></i>
                <span>{item.likes} 赞同</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}